import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import SystemLayout from './_layout';
import AnalyticsDashboard from '@rad/components/analytics/AnalyticsDashboard';
const SystemAnalytics = () => (_jsx(SystemLayout, { title: "Analytics", active: "analytics", children: _jsx(AnalyticsDashboard, { tenantId: null, canCreate: true, canDelete: true }) }));
export default SystemAnalytics;
